// Angular
import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Afidium
import { Yii } from "libraries/interfaces/Yii";
import { ConfigFieldBuilderService } from "../config-field-builder.service";
import { PRICING_ARRAY_FIELD } from "../config";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { HelperService } from "app_sasha/shared/services/helper.service";
import { BookingService } from 'libraries/service/booking/booking.service';
import { ApiPricingRate, ApiPricingXState } from "libraries/service/resources/booking/interfaces/ApiSearchParameters";

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'pricing-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="pricingSearchTitle" [open]="open">
                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <multiselect
                            [fieldConfig]="formFields.pricingRate"
                            [options]="pricingRateOptions"></multiselect>
                    </div>

                    <div class="flex-1 sep-left">
                        <multiselect
                            [fieldConfig]="formFields.pricingXState"
                            [options]="pricingXStateOptions"></multiselect>
                    </div>
                </div>

                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <chips [fieldConfig]="formFields.pricingFarebasis" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>
            </collapsible>
        </div>
    `
})
export class PricingFieldsetComponent {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @Input()
    public chipsToUpper: boolean;

    public readonly pricingSearchTitle = Yii.t('wui-sasha-js', 'Tarifications');

    public formFields: IFieldConfig;

    public pricingRateOptions: IMultiselectOptions[];
    public pricingXStateOptions: IMultiselectOptions[];

    constructor(
        private configFieldBuilderService: ConfigFieldBuilderService,
        private helperService: HelperService,
        private bookingService: BookingService
    ) { }

    public ngOnInit(): void {
        this.formFields = this.configFieldBuilderService.buildFieldConfigArray(this.form, PRICING_ARRAY_FIELD);

        this.pricingRateOptions = this.helperService.getMultiselectOptions(
            this.bookingService.pricingRateLabels,
            Object.values(ApiPricingRate),
            true
        );

        this.pricingXStateOptions = this.helperService.getMultiselectOptions(
            this.bookingService.pricingXStateLabels,
            Object.values(ApiPricingXState),
            true
        );
    }
}
